import React, { type FC, useCallback } from 'react';
import { pick } from 'lodash-es';
import { Form as CoreForm } from '@is24at/react-ui-core/Form';
import { LocalStorageKey } from '@is24at/react-enums';
import { useLocalStorage } from '@is24at/react-hooks';
import { scrollToTop } from 'utils/utils';
import { useFormDefaultValues } from 'utils/hooks/useFormDefaultValues';
import { formSubmit, formSubmitRequest } from '../../modules/form';
import FormControls from './FormControls';
import styles from './Form.scss';

const Form: FC<any> = ({
  mandatoryFields,
  companyName,
  cwid,
  formSubmitted,
  formSubmitStatus,
  isSafari,
  trackingFn,
  dispatch,
}) => {
  const initialValues = useFormDefaultValues();
  const sanitizedInitialValues = pick(
    initialValues,
    ...mandatoryFields.map((field) => field.name),
    'salutation',
    'firstName',
    'lastName',
    'email',
    'phoneNumber',
    'messageBody',
    'isHomeowner',
  );
  const [localStorageFormValues, persistLocally] = useLocalStorage(
    LocalStorageKey.CONTACT_REQUEST_FORM_KEY,
  );

  const onFormSubmit = useCallback(
    async (data) => {
      formSubmitRequest()(dispatch);
      await formSubmit(data, cwid)(dispatch);
      trackingFn();
      persistLocally({
        // forms may have different fields number,
        // overwrite only the actual form values not the entire key
        ...localStorageFormValues,
        ...data,
      });
      scrollToTop(2);
    },
    [persistLocally, localStorageFormValues, dispatch, cwid, trackingFn],
  );

  return (
    <div className={styles.container}>
      <CoreForm
        onSubmit={onFormSubmit}
        formSettings={{ defaultValues: sanitizedInitialValues }}
      >
        <FormControls
          contactRequestConfiguration={mandatoryFields}
          companyName={companyName}
          formSubmitted={formSubmitted}
          formSubmitStatus={formSubmitStatus}
          isSafari={isSafari}
        />
      </CoreForm>
    </div>
  );
};

export default Form;
